import React from 'react';
import Head from 'next/head';

interface SeoProps {
  title: string;
  metaDesc: string;
  metaTags: string;
  metaRobots: string;
  canonical: string;
  structuredData?: string;
}
export const Seo = ({
  title,
  metaDesc,
  metaTags,
  metaRobots,
  canonical,
  structuredData,
}: SeoProps) => (
  <Head>
    <title>{title || 'Unique Gift Ideas and Personalised Gifts | notonthehighstreet.com'}</title>
    {metaDesc && <meta name="description" content={metaDesc} />}
    {metaTags && <meta name="keywords" content={metaTags} />}
    {metaRobots && <meta name="robots" content={metaRobots} />}
    {canonical && <link rel="canonical" href={canonical} />}
    {structuredData && <script type="application/ld+json">{structuredData}</script>}
  </Head>
);
